import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  CircularProgress,
} from "@material-ui/core";

// Transition for Dialog
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddUpdateProjects = (props) => {
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    vendor_id: null,
    user_id: null,
    foreman_id: null,
    start_date: null,
  });

  // State to store the dropdown options for vendors and users
  const [vendors, setVendors] = useState([]);
  const [foremans, setForemans] = useState([]);
  const [users, setUsers] = useState([]);

  // Reset form to initial state
  const resetForm = () => {
    setFormData({
      name: "",
      vendor_id: null,
      user_id: null,
      foreman_id: null,
      start_date: null,
    });
  };

  // Fetch users and vendors from the API
  const getUsersAndVendorsAndForemans = () => {
    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getCustomersForAdminReview`)
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        toast.error("Error getting users");
      });

    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getVendorsForAdminReview`)
      .then((response) => {
        setVendors(response.data);
      })
      .catch((error) => {
        toast.error("Error getting vendors");
      });

    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getForeman`)
      .then((response) => {
        setForemans(response.data);
      })
      .catch((error) => {
        toast.error("Error getting Foreman");
      });
  };

  // On component mount or prop change, fetch the data
  useEffect(() => {
    if (props.open) {
      if (props.id > 0) {
        getFormData(); 
      } else {
        resetForm(); 
      }
    } else {
      resetForm(); 
    }
  }, [props.open, props.id]); 

  const getFormData = () => {
    if (!props.id) return; 

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/admin/projects/getById/${props.id}`, 
    })
      .then((response) => {
        setFormData({
          id: props.id,
          name: response.data.name,
          vendor_id: response.data.vendor_id,
          user_id: response.data.user_id,
          start_date: response.data.start_date,
        });
      })
      .catch((error) => {
        toast.error("Failed to load data");
      });
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const saveForm = () => {
    setSaveIsLoading(true);

    const apiUrl =
      props.id > 0
        ? `${process.env.REACT_APP_API}/admin/projects/update` 
        : `${process.env.REACT_APP_API}/admin/projects/add`; 

    axios({
      method: "post",
      url: apiUrl,
      data: formData,
    })
      .then((response) => {
        toast.success("Saved successfully");
        setSaveIsLoading(false);
        props.onClose(true); 
      })
      .catch((error) => {
        setSaveIsLoading(false);
        toast.error("Error while saving");
      });
  };

  useEffect(() => {
    getUsersAndVendorsAndForemans();
    resetForm();
  }, [props.open]);

  return (
    <Dialog
      fullScreen
      open={props.open}
      onClose={props.onClose}
      TransitionComponent={Transition}
      style={{ zIndex: 2235 }}
    >
      <AppBar className="position-relative">
        <Toolbar>
          <button
            type="button"
            className="close-modal-button"
            onClick={() => props.onClose(false)}
          >
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">Add Project</h4>
        </Toolbar>
      </AppBar>

      <div style={{ padding: "25px" }}>
        <div className="row">
          {/* Project Name Input */}
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="name">Project Name</label>
              <input
                type="text"
                className="form-control"
                id="name"
                onChange={handleInputChange}
                value={formData.name}
              />
            </div>
          </div>

          {/* User Dropdown */}
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="user_id">User</label>
              <select
                id="user_id"
                className="form-control"
                onChange={handleInputChange}
                value={formData.user_id || ""}
              >
                <option value="">Select User</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Vendor Dropdown */}
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="vendor_id">Vendor</label>
              <select
                id="vendor_id"
                className="form-control"
                onChange={handleInputChange}
                value={formData.vendor_id || ""}
              >
                <option value="">Select Vendor</option>
                {vendors.map((vendor) => (
                  <option key={vendor.id} value={vendor.id}>
                    {vendor.first_name} {vendor.last_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Foreman Dropdown */}
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="foreman_id">Foreman</label>
              <select
                id="foreman_id"
                className="form-control"
                onChange={handleInputChange}
                value={formData.foreman_id || ""}
              >
                <option value="">Select Foreman</option>
                {foremans.map((foreman) => (
                  <option key={foreman.id} value={foreman.id}>
                    {foreman.first_name} {foreman.last_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Start Date */}
          <div className="col-sm-12 col-md-6">
            <div className="form-group">
              <label htmlFor="start_date">Start Date</label>
              <input
                type="date"
                className="form-control"
                id="start_date"
                value={formData.start_date || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* Save Button */}
          <div className="col-sm-12 mt-5">
            {saveIsLoading ? (
              <CircularProgress />
            ) : (
              <button
                className="btn btn-md btn-primary float-end"
                onClick={saveForm}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddUpdateProjects;
